var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.link}},[_c('div',{staticClass:"rounded-full py-2 px-4 bouton openSans font-bold"},[_c('i',{staticClass:"fab fa-facebook-f"}),_vm._v("\n          \n        |   "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }